// ABOUTME: Lógica pura del visor 360: posición del dedo → instante del vídeo (en bucle) y los
// ABOUTME: instantes de los fotogramas fijos (perfil derecho, espaldas, perfil izquierdo).

/** Instante del vídeo tras arrastrar `dx` píxeles desde `startTime`; un ancho = una vuelta. */
export function scrubTime(startTime: number, dx: number, width: number, duration: number): number {
  const t = startTime + (dx / width) * duration;
  return ((t % duration) + duration) % duration;
}

/** Con el prompt de cuartos de vuelta: 2 s perfil derecho, 4 s espaldas, 6 s perfil izquierdo. */
export function orbitStillTimes(duration: number): [number, number, number] {
  return [duration * 0.25, duration * 0.5, duration * 0.75];
}

export interface YawSample {
  time: number;
  /** Yaw en grados (positivo = la cara mira hacia la derecha de la imagen); null si no hay cara. */
  yaw: number | null;
}

/**
 * Elige los instantes de perfil derecho, espaldas y perfil izquierdo a partir de muestras de
 * orientación de la cara: el giro de Veo no es uniforme, así que no valen instantes fijos.
 */
export function pickOrbitFrames(samples: YawSample[], duration = 8): { right: number; back: number; left: number } {
  const seen = samples.filter((s) => s.yaw !== null) as Array<{ time: number; yaw: number }>;
  if (seen.length === 0) return { right: duration * 0.25, back: duration * 0.5, left: duration * 0.75 };
  const right = seen.reduce((a, b) => (b.yaw > a.yaw ? b : a));
  const left = seen.reduce((a, b) => (b.yaw < a.yaw ? b : a));
  // Espaldas: centro del tramo más largo sin cara; si siempre hay cara, punto medio entre los máximos.
  let bestStart = -1;
  let bestLen = 0;
  let runStart = -1;
  samples.forEach((s, i) => {
    if (s.yaw === null) {
      if (runStart < 0) runStart = i;
      const len = i - runStart + 1;
      if (len > bestLen) {
        bestLen = len;
        bestStart = runStart;
      }
    } else runStart = -1;
  });
  const back = bestLen > 0 ? (samples[bestStart].time + samples[bestStart + bestLen - 1].time) / 2 : (right.time + left.time) / 2;
  return { right: right.time, back, left: left.time };
}
